import * as React from 'react';

import { Link } from '../link/link';

const s = require('./service_ads.css');

interface IProps {
  onClick(): void;
  title: string;
  description: string;
  buttonUrl: string;
  buttonText: string;
  isPremiumButton?: boolean;
  isNewTab?: boolean;
  class?: string;
}

export const ServiceAds = (props: IProps) =>
  <div className={`${s['c-selfads-item']} ${props.class || ''}`}>
    <h3 className={s['c-selfads-item-title']}>
      <span className={s['c-selfads-item-title-text']}>{props.title}</span>
    </h3>
    <div className={s['c-selfads-item-description']}>{props.description}</div>
    <Link
      onClick={() => props.onClick()}
      className={`${s['c-selfads-item-button']} ${props.isPremiumButton ? s['c-premium-btn'] : ''}`}
      href={props.buttonUrl} target={props.isNewTab ? '_blank' : '_self'}>{props.buttonText}</Link>
  </div>;
